<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card no-shadow>
          <template slot="actions">
              <div class="flex items-center gap-4">
                <div class="flex items-center gap-2">
                  <span class="label">Change View :</span>

                  <vs-switch
                    v-model="altView"
                    icon-pack="feather"
                  >
                    <span slot="on">ALT</span>
                    <span slot="off">MAIN</span>
                  </vs-switch>
                </div>
                <vs-button
                  v-if="$canAll(formulationPermissions)"
                  :disabled="formulation.work_orders_in_progress.length > 0"
                  @click="onClickAddRawMaterialToFormulation"
                  color="primary"
                  size="small"
                  type="filled"
                >
                  Add/Remove RMs
                </vs-button>

    </div>
          </template>
          <div slot="no-body" class="mt-4" id="printTableDiv">

            <vs-table sort :hoverFlat="true" id="formulation_table" noDataText="No raw materials available"
                      :data="raw_material_items" stripe
                      class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="manufacture_order" class="__table-heading-small" width="5%">MON</vs-th>
                <vs-th class="__table-heading-small" width="10%">ITS PROD CODE</vs-th>
                <vs-th class="__table-heading-small" width="10%">PROD NAME</vs-th>
                <vs-th class="__table-heading-small" width="10%">RM STATUS</vs-th>
                <vs-th v-if="showFormulationColumns" class="__table-heading-small" width="10%">RM QUANTITY IN BATCH (KG)</vs-th>
                <vs-th v-if="showFormulationColumns" class="__table-heading-small" width="10%">%</vs-th>
                <vs-th v-if="showFormulationColumns && formulation_type === 'spray dry powder'" class="__table-heading-small" width="5%">FINISH QUANTITY IN BATCH (KG)</vs-th>
                <vs-th v-if="showFormulationColumns && formulation_type === 'spray dry powder'" class="__table-heading-small" width="5%">FINISH % IN BATCH</vs-th>
                <vs-th class="__table-heading-small" width="5%">SOL</vs-th>
                <vs-th class="__table-heading-small" width="5%">HALAL</vs-th>
                <vs-th class="__table-heading-small" width="5%">KOSHER</vs-th>
                <vs-th class="__table-heading-small" width="10%" v-if="!altView">RM COST IN USE (£/KG)</vs-th>
                <vs-th class="__table-heading-small" width="10%" v-if="altView">CAS NUMBER</vs-th>
                <vs-th class="__table-heading-small" width="10%" v-if="!altView">RM COST /KG</vs-th>
                <vs-th class="__table-heading-small" width="10%" v-if="altView">FEMA NUMBER</vs-th>
                <vs-th class="__table-heading-small ml-auto mr-0 float-right" width="" v-if="!altView">FULL BATCH MAN PRICE /KG</vs-th>
                <vs-th class="__table-heading-small ml-auto mr-0" width="5%" v-if="altView">JECFA NUMBER</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td
                    v-if="!(tr.raw_material_items && tr.raw_material_items.length > 0) && isIncludedDilCodedFormulation">
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].manufacture_order">
                    {{ data[indextr].manufacture_order }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].company_product_code">

                    <span v-if="tr.formulation_code" style="cursor: pointer" class="text-primary">
                        {{ data[indextr].formulation_code }}
                    </span>
                    <vx-tooltip v-if="tr.company_product_code" text="View raw material" position="left">
                      <span style="cursor: pointer" class="text-primary" @click="onClickLinkToRm(data[indextr].id)">
                        {{ data[indextr].category + ' ' + data[indextr].company_product_code }}
                      </span>
                    </vx-tooltip>
                    <span v-if="tr.code" style="cursor: pointer">
                        {{ data[indextr].code }}
                    </span>
                  </vs-td>
                  <vs-td class="__table-heading-small">
                    <span v-if="tr.company_product_name">{{ data[indextr].company_product_name }}</span>
                    <span v-if="tr.name">{{ data[indextr].name }}</span>
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].status">
                    <vs-chip size="small" transparent class="__table-heading-small" color="" v-if="tr.status">
                      {{ typeof data[indextr].status === 'string' ? data[indextr].status  : data[indextr].status.name }}
                    </vs-chip>
                    <vs-chip v-if="tr.is_3rd_party_rm" size="small" transparent class="__table-heading-small text-xs" color="danger">
                      RMs from 3rd party
                    </vs-chip>
                    <vs-chip v-if="tr.is_liquid" size="small" transparent class="__table-heading-small text-xs" color="primary">
                      Liquid
                    </vs-chip>
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].quantity" v-if="showFormulationColumns">
                    <vx-input-group class="">
                      <vs-input :disabled="!isOnEditMode" v-on:input="onTestQtyChange(data[indextr].quantity)" v-model="data[indextr].quantity"
                                size=""/>
                    </vx-input-group>
                  </vs-td>

                  <vs-td class="__table-heading-small" v-if="showFormulationColumns">
                    <vx-input-group class="w-full">
                      <vs-input :disabled="!isOnEditMode" v-on:input="onTestPercentageChange(data[indextr].percentage)"
                                v-model="data[indextr].percentage" size=""/>
                    </vx-input-group>
                  </vs-td>

                  <vs-td v-if="showFormulationColumns && formulation_type === 'spray dry powder'" class="__table-heading-small">
                    <vx-input-group class="" v-if="data[indextr].is_liquid">
                      <vs-input :disabled="!isOnEditMode" v-on:input="onFinishQtyChange(data[indextr])" v-model="data[indextr].finish_quantity"
                                size=""/>
                    </vx-input-group>
                    <span v-if="!data[indextr].is_liquid">
                      {{ data[indextr].finish_quantity }}
                    </span>
                  </vs-td>

                  <vs-td v-if="showFormulationColumns && formulation_type === 'spray dry powder'" class="__table-heading-small">
                    {{ data[indextr].finish_percentage }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].dissolvable">
                    {{ data[indextr].dissolvable === 'Yes' ? 'S' : '' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].halal_suitable">
                    {{ suitableOrCertified(data[indextr].halal_suitable, data[indextr].halal_certified) }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].kosher_suitable">
                    {{ suitableOrCertified(data[indextr].kosher_suitable, data[indextr].kosher_certified) }}
                  </vs-td>

                  <vs-td class="__table-heading-small" v-if="!altView">
                    {{ ((data[indextr].quantity * data[indextr].cost) / calTotalFinishQuantity()).toFixed(2) }}
                  </vs-td>

                  <vs-td class="__table-heading-small" v-if="altView">
                    {{ getProductIdentity(data[indextr], 'cas_number') }}
                  </vs-td>

                  <vs-td class="__table-heading-small ml-auto " :data="data[indextr].cost" v-if="!altView">
                    {{ (data[indextr].cost).toFixed(2) }}
                  </vs-td>

                  <vs-td class="__table-heading-small" v-if="altView">
                    {{ getProductIdentity(data[indextr], 'fema_number') }}
                  </vs-td>

                  <vs-td class="__table-heading-small ml-auto float-right" :data="data[indextr].batch_weight" v-if="!altView">
                    {{ (data[indextr].quantity * data[indextr].cost).toFixed(2) }}
                  </vs-td>

                  <vs-td class="__table-heading-small" v-if="altView">
                    {{ getProductIdentity(data[indextr], 'jecfa_number') }}
                  </vs-td>

                  <template v-if="tr.raw_material_items && tr.raw_material_items.length > 0" class="expand-user"
                            slot="expand">
                    <div class="con-expand-users w-4/5">
                      <vs-table :data="tr.raw_material_items.concat(tr.formulation_items)">


                        <template slot="thead">
                          <vs-th class="__table-heading-small" width="20%">ITS PROD CODE</vs-th>
                          <vs-th class="__table-heading-small" width="30%">PROD NAME</vs-th>
                          <vs-th class="__table-heading-small" width="10%">RM/PRODUCT STATUS</vs-th>
                          <vs-th class="__table-heading-small" width="10%" v-if="showFormulationColumns" >QUANTITY (KG)</vs-th>
                          <vs-th class="__table-heading-small" width="10%">SOL</vs-th>
                          <vs-th class="__table-heading-small" width="10%">HALAL</vs-th>
                          <vs-th class="__table-heading-small" width="10%">KOSHER</vs-th>
                          <vs-th class="__table-heading-small" width="10%" v-if="altView">CAS NUMBER</vs-th>
                          <vs-th class="__table-heading-small" width="10%" v-if="altView">FEMA NUMBER</vs-th>
                          <vs-th class="__table-heading-small" width="10%" v-if="altView">JECFA NUMBER</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_item" v-for="(tr_rm_item, index_item) in data">

                            <vs-td>
                              <span v-if="tr_rm_item.formulation_code">
                                {{ tr_rm_item.formulation_code }}
                              </span>
                              <span v-if="!tr_rm_item.formulation_code">
                                {{ tr_rm_item.category + ' ' + tr_rm_item.company_product_code }}
                              </span>
                            </vs-td>

                            <vs-td>
                              <span v-if="tr_rm_item.company_product_name">{{ tr_rm_item.company_product_name }}</span>
                              <span v-if="tr_rm_item.name">{{ tr_rm_item.name }}</span>
                            </vs-td>

                            <vs-td>
                              {{ typeof tr_rm_item.status === 'string' ? tr_rm_item.status  : tr_rm_item.status.name }}
                            </vs-td>

                            <vs-td v-if="showFormulationColumns" >
                              {{ Number(tr_rm_item.quantity).toFixed(3) }}
                            </vs-td>

                            <vs-td>
                              {{ tr_rm_item.dissolvable === 'Yes' ? 'S' : '' }}
                            </vs-td>

                            <vs-td>
                              {{ suitableOrCertified(tr_rm_item.halal_suitable, tr_rm_item.halal_certified) }}
                            </vs-td>

                            <vs-td>
                              {{ suitableOrCertified(tr_rm_item.kosher_suitablevv, tr_rm_item.kosher_certified) }}
                            </vs-td>
                            <vs-td v-if="altView">
                              {{ getProductIdentity(tr_rm_item, 'cas_number') }}
                            </vs-td>
                            <vs-td v-if="altView">
                              {{ getProductIdentity(tr_rm_item, 'fema_number') }}
                            </vs-td>
                            <vs-td v-if="altView">
                              {{ getProductIdentity(tr_rm_item, 'jecfa_number') }}
                            </vs-td>

                            <template class="expand-user"
                                      slot="expand">
                              <div class="con-expand-users w-4/5">
                                <vs-table v-if="tr_rm_item.raw_material_items && tr_rm_item.raw_material_items.length > 0"
                                          :data="tr_rm_item.raw_material_items.concat(tr_rm_item.formulation_items)">


                                  <template slot="thead">
                                    <vs-th class="__table-heading-small" width="20%">ITS PROD CODE</vs-th>
                                    <vs-th class="__table-heading-small" width="30%">PROD NAME</vs-th>
                                    <vs-th class="__table-heading-small" width="10%">RM/PRODUCT STATUS</vs-th>
                                    <vs-th class="__table-heading-small" width="10%" v-if="showFormulationColumns">QUANTITY (KG)</vs-th>
                                    <vs-th class="__table-heading-small" width="10%">SOL</vs-th>
                                    <vs-th class="__table-heading-small" width="10%">HALAL</vs-th>
                                    <vs-th class="__table-heading-small" width="10%">KOSHER</vs-th>
                                    <vs-th class="__table-heading-small" width="10%" v-if="altView">CAS NUMBER</vs-th>
                                    <vs-th class="__table-heading-small" width="10%" v-if="altView">FEMA NUMBER</vs-th>
                                    <vs-th class="__table-heading-small" width="10%" v-if="altView">JECFA NUMBER</vs-th>
                                  </template>

                                  <template slot-scope="{data}">
                                    <vs-tr :key="index_item_item" v-for="(tr_rm_item_item, index_item_item) in data">

                                      <vs-td>
                                        <span v-if="tr_rm_item_item.formulation_code">
                                          {{ tr_rm_item_item.formulation_code }}
                                        </span>
                                        <span v-if="!tr_rm_item_item.formulation_code">
                                          {{ tr_rm_item_item.category + ' ' + tr_rm_item_item.company_product_code }}
                                        </span>
                                      </vs-td>

                                      <vs-td>
                                        <span v-if="tr_rm_item_item.company_product_name">{{ tr_rm_item_item.company_product_name }}</span>
                                        <span v-if="tr_rm_item_item.name">{{ tr_rm_item_item.name }}</span>
                                      </vs-td>

                                      <vs-td>
                                        {{ typeof tr_rm_item_item.status === 'string' ? tr_rm_item_item.status  : tr_rm_item_item.status.name }}
                                      </vs-td>

                                      <vs-td v-if="showFormulationColumns">
                                        {{ Number(tr_rm_item_item.quantity).toFixed(3) }}
                                      </vs-td>

                                      <vs-td>
                                        {{ tr_rm_item_item.dissolvable === 'Yes' ? 'S' : '' }}
                                      </vs-td>

                                      <vs-td>
                                        {{ suitableOrCertified(tr_rm_item_item.halal_suitable, tr_rm_item_item.halal_certified) }}
                                      </vs-td>

                                      <vs-td>
                                        {{ suitableOrCertified(tr_rm_item_item.kosher_suitablevv, tr_rm_item_item.kosher_certified) }}
                                      </vs-td>
                                      <vs-td v-if="altView">
                                        {{ getProductIdentity(tr_rm_item_item, 'cas_number') }}
                                      </vs-td>
                                      <vs-td v-if="altView">
                                        {{ getProductIdentity(tr_rm_item_item, 'fema_number') }}
                                      </vs-td>
                                      <vs-td v-if="altView">
                                        {{ getProductIdentity(tr_rm_item_item, 'jecfa_number') }}
                                      </vs-td>

                                    </vs-tr>
                                  </template>

                                </vs-table>
                              </div>
                            </template>

                          </vs-tr>
                        </template>

                      </vs-table>
                    </div>
                  </template>

                </vs-tr>

                <vs-tr v-if="raw_material_items.length > 0">
                  <vs-td v-if="isIncludedDilCodedFormulation"></vs-td>
                  <vs-td colspan="2" class="font-bold">
                    ( Total number of items - {{ formulation.items_count }} )
                  </vs-td>
                  <vs-td colspan="2">
                    <b>Total</b>
                  </vs-td>
                  <vs-td v-if="showFormulationColumns">
                    <b>{{ calTotalQuantity() }}</b>
                  </vs-td>
                  <vs-td v-if="showFormulationColumns">
                    <b>{{ calTotalPresentage() }} %</b>
                  </vs-td>
                  <vs-td v-if="showFormulationColumns && formulation_type === 'spray dry powder'">
                    <b>{{ calTotalFinishQuantity() }}</b>
                  </vs-td>
                  <vs-td v-if="showFormulationColumns && formulation_type === 'spray dry powder'">
                    <b>{{ calTotalFinishPercentage() }} %</b>
                  </vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td>
                    <b v-if="!altView">{{ calTotalPerKgCost() }}</b>
                  </vs-td>
                  <vs-td></vs-td>
                  <vs-td class="float-right">
                    <b v-if="!altView">{{ calTotalValue() }}</b>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
          </div>

          <div class="vx-row hidden" v-if="spray_dry_carriers.length > 0">
            <div class="vx-col w-full">
              <vs-table sort :hoverFlat="true" id="formulation_table" noDataText="No raw materials available"
                      :data="spray_dry_carriers" stripe
                      class="table-dark-inverted table-auto vs-con-loading__container">

                <template slot="thead">
                  <vs-th class="__table-heading-small" width="5%">MON</vs-th>
                  <vs-th class="__table-heading-small" width="5%">PROD CODE</vs-th>
                  <vs-th class="__table-heading-small" width="5%">PROD NAME</vs-th>
                  <vs-th class="__table-heading-small" width="5%">QUANTITY IN BATCH (KG)</vs-th>
                  <vs-th class="__table-heading-small" width="5%">%</vs-th>
                  <vs-th class="__table-heading-small" width="10%" v-if="!altView">COST IN USE (£/KG)</vs-th>
                  <vs-th class="__table-heading-small" width="10%" v-if="!altView">COST /KG</vs-th>
                   <vs-th class="__table-heading-small ml-auto mr-0 float-right" width="" v-if="!altView">FULL BATCH MAN PRICE /KG</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                      {{ data[indextr].manufacture_order }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].code }}
                    </vs-td>
                    <vs-td>
                      {{ data[indextr].name }}
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <div class="vx-row">
            <div v-if="$canAll(formulationPermissions)" class="vx-col w-full">
              <vs-button @click="onClickSaveConfirm()" v-if="isOnEditMode" class="float-right" color="primary" size="small" type="filled">
                Save changes
              </vs-button>
              <vs-button @click="isOnEditMode = !isOnEditMode" v-if="!isOnEditMode" class="float-right" color="primary" size="small" type="filled"
                :disabled="formulation.work_orders_in_progress.length > 0">
                Edit formulation ratios
              </vs-button>
              <vs-button @click="onClickOrderChange()" class="float-right mr-2" color="primary" size="small"
                         type="filled" :disabled="formulation.work_orders_in_progress.length > 0">Manufacture Order change
              </vs-button>
              <vs-button v-if="isIncludedCarrierRawMaterial" @click="onClickRational()" class="float-right mr-2"
                         color="primary" size="small" type="filled">Rationalisations
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <raw-material-add-to-formulation-pop-up v-bind:raw_material_items="raw_material_items_without_carriers" :spray_dry_carriers="spray_dry_carriers"
                                            ref="rawMaterialAddToFormulationPopUp" :formulation_type="formulation_type"/>
    <item-order-change-pop-up ref="itemOrderChangePopUp"/>
    <formulation-rationalisation-pop-up v-on:refresh="refreshAll()" ref="formulationRationalisationPopUp"/>
    <formulation-rationalisation-duplicate-pop-up :formulationPermissions="formulationPermissions" v-on:refresh="refreshAll()" ref="formulationRationalisationDuplicatePopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const FormulationsRepository = RepositoryFactory.get('formulations')
import RawMaterialAddToFormulationPopUp from '@/components/popups/formulations/RawMaterialAddToFormulationPopUp'
import ItemOrderChangePopUp from '@/components/popups/formulations/formulation-order/ItemOrderChangePopUp'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Utils from '@/mixins/Utils'
import FormulationRationalisationPopUp
  from "@/components/popups/formulations/rationalisation/FormulationRationalisationPopUp";
import FormulationRationalisationDuplicatePopUp
  from "@/components/popups/formulations/rationalisation/FormulationRationalisationDuplicatePopUp";

export default {
  name: "FormulationGeneral",
  components: {
    RawMaterialAddToFormulationPopUp,
    ItemOrderChangePopUp,
    FormulationRationalisationPopUp,
    FormulationRationalisationDuplicatePopUp,
  },
  data() {
    return {
      formulationId: '',
      formulation: {
        work_orders_in_progress: []
      },
      raw_material_items: [],
      totalQty: null,
      isOnEditMode: false,
      altView: false,
      spray_dry_carriers: []
    }
  },
  props: {
    formulationPermissions: {
      type: Array,
      default: [],
    },
    isProductionFormulation: {
      type: Boolean,
      default: true
    },
    isFullyDilCodedFormulation: {
      type: Boolean,
      default: false
    },
    status_name: {
      type: String,
      default: 'Production'
    },
    linked_formulations_to_dilution: {
      type: Array,
      default: () => []
    },
    formulation_type: {
      type: String,
      default: null
    }
  },
  methods: {
    async refreshData() {
      await this.loadFormulations()
    },
    async refreshAll() {
      await this.loadFormulations()
      this.$emit('refreshGeneral')
    },
    async onClickLinkToRm(id) {
      this.$router.push({path: `/pages/manage-nimble/suppliers/${id}/raw-material/${id}`})
    },
    async loadFormulations() {
      await this.$vs.loading({
        container: '#formulation_table',
        scale: 0.45
      })
      try {
        const {data} = await FormulationsRepository.details(this.formulationId)
        this.formulation = data.data
        this.spray_dry_carriers = data.data.spray_dry_carriers.map(carrier => {
          carrier.cost = Number(carrier.price)
          carrier.is_3rd_party_rm = true,
          carrier.is_liquid = carrier.is_liquid
          return carrier
        })

        if (this.formulation.formulation_items.length > 0) {
          this.raw_material_items = this.formulation.raw_material_items.concat(this.formulation.formulation_items)
        } else {
          this.raw_material_items = this.formulation.raw_material_items
        }
        if(this.formulation.formulation_type === 'spray dry powder' && this.spray_dry_carriers.length > 0) {
          this.raw_material_items = this.raw_material_items.concat(this.spray_dry_carriers)
        }

        this.raw_material_items = this.raw_material_items.map((x) => {
          x.cost = Number(x.cost)
          x.quantity = Number(x.quantity)
          return x
        })

        this.raw_material_items = this.raw_material_items.map((n) => {
          n.percentage = ((n.quantity / this.calTotalQuantity()) * 100).toFixed(2)
          return n
        })

        this.raw_material_items = this.raw_material_items.map((n) => {
          n.finish_quantity = n.is_liquid ? (n.finished_quantity || 0) : n.quantity 
          return n
        })

        this.raw_material_items = this.raw_material_items.map((n) => {
          n.finish_percentage = ((n.finish_quantity / this.calTotalFinishQuantity()) * 100).toFixed(2)
          return n
        })

        this.raw_material_items = this.raw_material_items.sort((a, b) => {
          if (a.manufacture_order < b.manufacture_order) return -1
          return a.manufacture_order > b.manufacture_order ? 1 : 0
        })
        this.totalQty = this.calTotalQuantity()
      } catch (e) {

      }
      this.$vs.loading.close('#formulation_table > .con-vs-loading')
    },
    async onClickAddRawMaterialToFormulation() {
      await this.$refs.rawMaterialAddToFormulationPopUp.openPopup(this.formulationId, this.isFullyDilCodedFormulation, this.isProductionFormulation && this.status_name === 'Production', this.linked_formulations_to_dilution)
    },
    async onClickOrderChange() {
      await this.$refs.itemOrderChangePopUp.openPopup(this.raw_material_items, this.formulationId)
    },
    async onClickRational() {
      await this.$refs.formulationRationalisationDuplicatePopUp.openPopup(this.raw_material_items, this.formulationId)
    },
    calTotalQuantity() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity)
      })
      return total.toFixed(2)
    },
    calTotalRmCost() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.cost)
      })
      return total.toFixed(2)
    },
    calTotalPerKgCost() {
      return Number(this.calTotalValue() / this.calTotalFinishQuantity()).toFixed(2)
    },
    calTotalValue() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.quantity) * Number(m.cost)
      })
      return total.toFixed(2)
    },
    calTotalPresentage() {
      // let total = 0;
      // this.raw_material_items.forEach((m) => {
      //   total = total + (Number(m.quantity) / Number(this.calTotalQuantity())) * 100
      //   // ((data[indextr].quantity / calTotalQuantity()) * 100)
      // })
      // return total.toFixed(2)

      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.percentage)
        // ((data[indextr].quantity / calTotalQuantity()) * 100)
      })
      return total.toFixed(2)
    },
    getProductIdentity(data, type){
      if(data.product_identity){
        const find = data.product_identity.find(product => product.raw_material_id  === data.id)
        if(find.product_identity){ 
          return find.product_identity[type]
        }
      }else {
        // return 'N/A'
      }
    },
    async onClickSaveConfirm() {
      if(this.isProductionFormulation && this.status_name === 'Production' && !this.isFullyDilCodedFormulation) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Warning',
            text: 'You are about to save an edit to a live formulation. This will suspend this formulation until QC has been approved for use. Confirm you wish to proceed?',
            acceptText: 'Confirm',
            accept: this.saveQuantity,
            cancel: this.loadFormulations
          })
      } else if(this.isFullyDilCodedFormulation && this.linked_formulations_to_dilution.length > 0) {
        const formulation_names = this.linked_formulations_to_dilution.map(f => `${f.name || ''} (${f.code || ''})`).join(', ');
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Warning',
            text: `( ${formulation_names} ) use this DIL code and will be suspended until QC reinstated. Are you sure you wish to make this change?`,
            acceptText: 'Confirm',
            accept: this.saveQuantity,
            cancel: this.loadFormulations
        })
      } else {
        await this.saveQuantity()
      }
    },
    async saveQuantity() {
      const vue = this;
      await this.$vs.loading({
        container: '#formulation_table',
        scale: 0.45
      })
      try {
        let rm_items = []
        Object.assign(rm_items, this.raw_material_items)
        const dil_coded_formulations = rm_items
          .filter((x) => x.formulation_code && /^DIL-|^EXT-|^KEY-/.test(x.formulation_code)).map((m) => ({
            id: m.id, quantity: Number(m.quantity).toFixed(4), manufacture_order: m.manufacture_order
          }))
        const raw_material_items = rm_items
          .filter((x) => !x.is_3rd_party_rm && !(x.formulation_code && /^DIL-|^EXT-|^KEY-/.test(x.formulation_code))).map((m) => ({
            id: m.id, quantity: Number(m.quantity).toFixed(4), manufacture_order: m.manufacture_order
          }))
        const carrier_items = rm_items
          .filter((x) => x.is_3rd_party_rm).map((m) => ({
            id: m.id, quantity: Number(m.quantity).toFixed(4), manufacture_order: m.manufacture_order + '', finished_quantity: m.is_liquid ? Number(m.finish_quantity).toFixed(4) : null
          }))
        await FormulationsRepository.updateFormulationsItems(this.formulationId, {
          raw_material_items: raw_material_items,
          formulation_items: dil_coded_formulations,
          carrier_items: carrier_items
        })
        this.totalQty = this.calTotalQuantity()
        this.showSuccessMessage('Formulation Updated!')
        // await this.loadFormulations()
        this.isOnEditMode = !this.isOnEditMode
        await this.refreshAll()
        vue.$forceUpdate();
      } catch (e) {
        this.$vs.loading.close('#formulation_table > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation_table > .con-vs-loading')
    },
    suitableOrCertified(suitable, certified) {
      let text = ''
      if (suitable === 'Yes') {
        text = text + ' S'
      }
      if (certified === 'Yes') {
        text = text + ' C'
      }
      return text
    },
    onTestQtyChange(qty) {
      if (Number(qty) > 0) {
        this.raw_material_items = this.raw_material_items.map((n) => {
          n.percentage = ((n.quantity / this.calTotalQuantity()) * 100).toFixed(2)
          n.finish_quantity = n.is_liquid ? (n.finish_quantity || 6) : n.quantity 
          return n
        })
        // this.search(qty, this);
      }
    },
    onTestPercentageChange(qty) {
      this.raw_material_items = this.raw_material_items.map((n) => {
        n.quantity = ((n.percentage / 100) * this.totalQty).toFixed(3)
        n.finish_quantity = n.is_liquid ? (n.finish_quantity || 6) : n.quantity 
        return n
      })
      // this.search(qty, this);
    },
    search: _.debounce(async (qty, vm) => {
      await vm.saveQuantity()
    }, 1000),
    onFinishQtyChange() {
      this.raw_material_items = this.raw_material_items.map((n) => {
        n.finish_percentage = ((n.finish_quantity / this.calTotalFinishQuantity()) * 100).toFixed(2)
        return n
      })
    },
    calTotalFinishQuantity() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.finish_quantity)
      })
      return total.toFixed(2)
    },
    calTotalFinishPercentage() {
      let total = 0;
      this.raw_material_items.forEach((m) => {
        total = total + Number(m.finish_percentage)
      })
      return total.toFixed(2)
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    await this.loadFormulations()
  },
  mixins: [SuccessMessage, ErrorMessages, Utils],
  computed: {
    showFormulationColumns() {
      const hasFullView = this.$can('view-formulations');
      const hasPartialView = this.$can('view-partial-formulation-details');

      // Full view overrides everything
      if (hasFullView) return true;

      // Only partial view means we hide the columns
      if (hasPartialView && !hasFullView) return false;

      // Default
      return false;
    },
    isIncludedDilCodedFormulation() {
      return this.formulation.formulation_items.length > 0
      // return this.raw_material_items.some((x) => x.formulation_code && x.formulation_code.includes('DIL-'))
    },
    isIncludedCarrierRawMaterial() {
      return this.raw_material_items.some((x) => x.category && x.category === 'CAR')
    },
    raw_material_items_without_carriers() {
      return this.raw_material_items.filter((x) => !(x.is_3rd_party_rm))
    }
  }
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
  font-size: 13px;
}

</style>
